import React from 'react';
import agent from '../../../agent';
import {connect} from 'react-redux';
import {ADD_COMMENT, COMMENT_MAX_CHARACTER, POST_MAX_CHARACTER} from '../../../constants/actionTypes';
import InfoModal from '../../../components/Utils/InfoModal';
import {createComment, createReplyComment} from '../../../actions/comments';
import MentionTextarea from '../../Utils/MentionTeaxtarea';
import {getLabel} from '../../../language'
import defaultAvatar from '../../../images/avatar.svg';
import "./SmallComments.css"
import {message} from "antd";
import anonymousAvatar from '../../../images/avatar.svg'

const parser = (markup) => {
    let temp= markup;
    const data = [...markup.matchAll(/@(\[(.*?)\])/g)]?.map((item=> {
        // console.log("just",`@[${item[2]}](${item[2]})`,`@${item[2]}`)
        // console.log("just",temp.replace(`@[${item[2]}](${item[2]})`,`@${item[2]}`))
        temp =  temp.replace(`@[${item[2]}](${item[2]})`,`@${item[2]}`)
        return temp
    }));

    return temp||'';
};

class SmallCommentInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
      isDisabledTextarea: true,
      text: '',
      replyMyPostsAndComments: this.props.post && this.props.post.replyMyPostsAndComments,
      post_chars_left: 0,
      post_max_char:COMMENT_MAX_CHARACTER,
    };

    this.onSubmitComment = this.onSubmitComment.bind(this);
    this.changeInput = this.changeInput.bind(this);
    this.onReplyComment = this.onReplyComment.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.showErrorReplyPrivate = this.showErrorReplyPrivate.bind(this);
  }

  componentDidMount() {
    const {currentUser} = this.props;
    this.setState({isDisabled: currentUser?.user_privilege?.mayReplyInPrivate});
    this.setState({isDisabledTextarea: currentUser?.user_privilege?.mayReplyToPublicPost});
  }

  onSubmitComment(ev) {
    ev.preventDefault();
    this.props.onSubmit(this.props.post.id, parser(this.state.text), parseInt(ev.target.value), parseInt(ev.target.value));
    this.props.addCommentClick();
    this.setState({
      text: '',
      replyMyPostsAndComments: parseInt(ev.target.value),
    })
  }

  onReplyComment(ev) {
    ev.preventDefault();
    this.props.onReplyComment(this.props.post.id, this.props.commentId, this.state.text, parseInt(ev.target.value), parseInt(ev.target.value));
    this.setState({
      text: '',
      replyMyPostsAndComments: parseInt(ev.target.value),
    })
  }

  changeInput(ev) {
    const char = ev.target.value.length;
    if(char <= COMMENT_MAX_CHARACTER){
        this.setState({text: ev.target.value,post_chars_left: char});
    }

  }

  openModal = () => {
    this.setState({isOpen: !this.state.isOpen})
  }

  showErrorReplyPrivate() {
    if (!this.state.isDisabled) {
      message.error(getLabel(274))
    }
  }

    checkedLogin=()=>{
        const data=localStorage.getItem('bearerToken')
        if(data!==null){
            return false
        }
    }

  render() {
    const {currentUser, user} = this.props;
    return (
      < div className="row comment-bottom-border justify-content-center">
        < InfoModal
          isOpen={this.state.isOpen}
          onClose={this.openModal}
          title={getLabel(62
          )
          }
          description={getLabel(58
          )
          }
          video={'https://www.youtube.com/embed/ji2f5WdYATA'}
        />
        <div>
          <a className="politician">
            {this.props.anonymousMode ? (< img
              src={anonymousAvatar
              }
              className="user-pic border-radius-10"
              alt='' />) :
              ( < img
              src = {user && user.avatar ? user.avatar : defaultAvatar
            }
              className = "user-pic border-radius-10"
              alt = '' />)
            }

            <span
              className={currentUser?.isVerified ? "gender verified" : `${parseInt(currentUser && currentUser.gender) === 1 && "female "}${parseInt(currentUser && currentUser.gender) === 2 && "male"}`
              }
            />
            </a>
        </div>
        <div
                  style={{width: '63%'}}>
                  <MentionTextarea
                    className="form-control with-border"
                    changeBody={this.changeInput}
                    rows={2}
                    value={this.state.text}
                    // disabled={this.props.isAvailableForReply === false || !this.state.isDisabledTextarea}
                    disabled={this.props.isAvailableForReply === false || !(this.props.currentUser?.user_privilege?.mayCommentMoreThan0TimesADay) || this.props.currentUser?.commentLimitReached || this.props?.post?.replyMyPostsAndComments === 0}
                    placeholder={localStorage.getItem('bearerToken')?(this.props?.post?.replyMyPostsAndComments === 0 ? getLabel(324) : (!(this.props.currentUser?.user_privilege?.mayCommentMoreThan0TimesADay) ? getLabel(320) : (this.props.currentUser?.commentLimitReached ? getLabel(321) : (getLabel(59)
                    )))):getLabel(461)
                    }
                    showMaxLengthCounter={true}
                    chars_left={this.state.post_chars_left}
                    max_chars={this.state.post_max_char}
                    maxlength={COMMENT_MAX_CHARACTER}
                    loggedIn={this.checkedLogin}
                  />
                  </div>
                    {/*<div className="col-md-1 col-1">*/
                    }
                    {/*  <a className="btn btn-default btn-sm small margintop" title="help" onClick={this.openModal} >*/
                    }
                    {/*    <i className="fa fa-question-circle pol" />*/
                    }
                    {/*  </a>*/
                    }
                    {/*</div>*/
                    }

          <div className="m-l-5">
            <span className="commentset text-right">
            <div onClick={this.showErrorReplyPrivate}>
            <button
              className={`btn btn-private${this.props.anonymousMode ? "-dark" : ""} replylink reply_private ${!this.state.isDisabled ? "replyInPrivate" : "form-check-label"} ${parseInt(this.state.replyMyPostsAndComments) === 1 && ''}`
              }
              value={1}

              title={getLabel(217
              )
              }
              onClick={this.props.replyComment ? this.onReplyComment : this.onSubmitComment}> </button>
            </div>
              {
                this
                  .props.replyMyPostsAndComments !== 1 &&  <button
                className = {`btn  btn-group${this.props.anonymousMode ? "-dark" : ""}  replylink reply_group ${parseInt(this.state.replyMyPostsAndComments) === 2 && ''}`
              }
                value = {2}
                title = {getLabel(218
                )
              }
                onClick = {this.props.replyComment ? this.onReplyComment : this.onSubmitComment} > </button>
              }
              {
                this.props.replyMyPostsAndComments !== 1 &&  <button
                className = {`btn btn-public${this.props.anonymousMode ? "-dark" : ""}  replylink reply_public ${parseInt(this.state.replyMyPostsAndComments) === 3 && ''}`
              }
                value = {3}
                title = {getLabel(219
                )
              }
                onClick = {this.props.replyComment ? this.onReplyComment : this.onSubmitComment}> </button>
              }
              </span>
          </div>

        </div>

    )
        ;
    }
}

message.config({top:50})

const mapStateToProps = state => {
          return {
          currentUser: state.common.currentUser,
          user: state.user,
          isOpen: false,
          anonymousMode: state.user.anonymousMode
        }
        };

const mapDispatchToProps = dispatch => ({
          onSubmit: dispatch(createComment),
          onReplyComment: dispatch(createReplyComment),
        });

export default connect(mapStateToProps, mapDispatchToProps)(SmallCommentInput);
